// Generated from SVG to Code Figma Plugin

export const ProductLineElementLibrary = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.33397 19.1978L4.08546 19.5023C2.94985 19.6088 1.95529 18.7455 1.90104 17.6062L1.42484 7.60585C1.374 6.53816 2.17167 5.61922 3.2359 5.51945L6.66732 5.19775"
      opacity="0.64"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M16.6719 19.1978L19.9204 19.5023C21.056 19.6088 22.0506 18.7455 22.1048 17.6062L22.581 7.60585C22.6319 6.53816 21.8342 5.61922 20.77 5.51945L17.3385 5.19775"
      opacity="0.64"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect height="16" width="10.6667" rx="2" stroke="currentColor" strokeWidth="1.5" x="6.66602" y="4" />
  </svg>
);
